import { createSlice } from '@reduxjs/toolkit'
import {
  fetchOrganisationById,
  fetchUser,
  updateOrganisation,
  updateStatusInOrg,
  exportUsersCSV,
  fetchALLUserFormDropdowns,
  updateStatusInUsers,
  fetchDropdownByColumn
} from './thunk'

interface OrganisationState {
  usersList: any[]
  rowCount: number
  loading: boolean
  error: string | null
  selectedOrganisation: any
  orgDropDown: any[]
  industryTypeDropDown: any[]
  orgCityDropDown: any[]
  orgStateDropDown: any[]
  pincodeDropDown: any[]
  dynamicDropdowns: Record<string, any[]>
  exportCSVLoading: boolean
  exportCSVError: string | null
  userFormDropDowns: {}
}

const initialState: OrganisationState = {
  usersList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  orgDropDown: [],
  industryTypeDropDown: [],
  orgCityDropDown: [],
  orgStateDropDown: [],
  pincodeDropDown: [],
  dynamicDropdowns: {},
  exportCSVLoading: false,
  exportCSVError: null,
  userFormDropDowns: {
    userTypes: [],
    organizations: [],
    departments: [],
    teams: [],
    states: []
  }
}

const organisationSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch users
      .addCase(fetchUser.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false
        state.usersList = Array.isArray(action.payload.data)
          ? action.payload.data
          : []
        state.rowCount =
          typeof action.payload.rowCount === 'number'
            ? action.payload.rowCount
            : 0
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch users'
      })

      // Fetch org by ID
      .addCase(fetchOrganisationById.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchOrganisationById.fulfilled, (state, action) => {
        state.loading = false
        state.selectedOrganisation = action.payload
      })
      .addCase(fetchOrganisationById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      // Update org
      .addCase(updateOrganisation.fulfilled, (state, action) => {
        if (!action.payload?.id) return
        state.usersList = state.usersList.map(org =>
          org.id === action.payload.id ? action.payload : org
        )
      })
      .addCase(updateOrganisation.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update organisation'
      })

      // Update status
      .addCase(updateStatusInUsers.fulfilled, (state: any, action: any) => {
        if (!action.payload?.id) return
        state.usersList = state.usersList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        )
      })
      .addCase(updateStatusInUsers.rejected, (state, action) => {
        state.loading = false
        state.error =
          action.error.message || 'Failed to update organisation status'
      })

      // CSV export
      .addCase(exportUsersCSV.pending, state => {
        state.exportCSVLoading = true
        state.exportCSVError = null
      })
      .addCase(exportUsersCSV.fulfilled, state => {
        state.exportCSVLoading = false
        state.exportCSVError = null
      })
      .addCase(exportUsersCSV.rejected, (state, action) => {
        state.exportCSVLoading = false
        state.exportCSVError =
          typeof action.payload === 'string'
            ? action.payload
            : action.error.message || 'Failed to export CSV'
      })

      // User form dropdowns
     .addCase(fetchALLUserFormDropdowns.fulfilled, (state, action) => {
  const payload:any = action.payload || {};
  console.log(payload,"payload-------------1")
  state.userFormDropDowns = payload;
  state.orgDropDown = Array.isArray(payload.organizations) ? payload.organizations : [];
})



      // Dynamic column dropdowns
      .addCase(fetchDropdownByColumn.fulfilled, (state:any, action:any) => {
        const columnId = action.meta.arg
        const key = `${columnId}DropDown`
        state.dynamicDropdowns = {
          ...state.dynamicDropdowns,
          [key]: action.payload
        }
      })
  }
})

export default organisationSlice.reducer
